import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MvRouteGuardService } from 'src/app/core/services/msal/guards/mv-route-guard.service';
import { LandingPageModule } from './features/landing-page/landing-page.module';
import { LoginComponent } from './features/login/login.component';
import { MsalRedirectComponent } from '@azure/msal-angular';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'auth', component: MsalRedirectComponent },
  {
    path: 'home',
    loadChildren: () => LandingPageModule,
    canActivate: [MvRouteGuardService],
    data: {headerApp:'headerApp'}
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
